import { useState } from 'react';
import { ReactComponent as MenuIcon } from '../../icons/menu.svg';
import Menu from '../menu/Menu';
import style from './Configuracoes.module.css';

const Configuracoes = ({ className="", layout="", accessLevel }) => {
  const [menuActive, setMenuActive] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const mudarMenu = () => {
    if (menuActive) {
      // Se o menu estiver ativo, adicione a classe de saída e, após a animação, remova-o do DOM
      setMenuActive(false);
      setTimeout(() => setShowMenu(false), 300); // Tempo deve coincidir com a duração da animação
    } else {
      // Se o menu não estiver ativo, mostre-o e adicione a classe de entrada
      setShowMenu(true);
      setTimeout(() => setMenuActive(true), 10); // Pequeno delay para garantir que a classe seja aplicada após o render
    }
  };

  // Função de callback que será passada para o Menu
  const handleMenuAction = () => {
    mudarMenu(); // Fecha o menu imediatamente quando qualquer ação for executada
  };

  return (
    <div className={className}>
      <MenuIcon className={style.menu_icon} height={27} width={27} onClick={mudarMenu} />
      {showMenu && <div className={style.menu_blur} onClick={mudarMenu}/>}
      {showMenu && 
        <Menu 
          className={`${style.menu} ${menuActive ? style.menu_active : ''}`} 
          accessLevel={accessLevel}
          layout={layout}
          onAction={handleMenuAction}
        />
      }
    </div>
  );
};

export default Configuracoes;
